<template>
  <div class="d-none" v-if="modalShow">
    <v-dialog
      v-model="modalShow"
      class="confirmModal"
      ref="confirmModal"
      hide-header
      hide-footer
      no-close-on-backdrop
      centered
      body-class="p-4"
      data-test="confirm-modal"
    >
      <div class="text-center">
        <span class="f-bold f-xl" v-if="header" data-test="confirm-modal-title">{{ header }}</span>
        <p
          class="text-text f-lg mt-3"
          v-if="text"
          v-html="text"
          data-test="confirm-modal-message"
        ></p>
        <div
          class="text-sub f-md"
          v-if="subText"
          v-html="subText"
          data-test="confirm-modal-sub-message"
        ></div>
      </div>
      <hr />
      <div class="text-center mt-3">
        <c-btn
          variant="confirm-primary"
          class="mb-3"
          block
          @click="handleOkModal"
          data-test="modal-confirm-button"
        >
          {{ button.true.msg }}</c-btn
        >
        <c-btn
          variant="outline-primary"
          class="mt-3"
          block
          @click="handleCloseModal"
          data-test="modal-cancel-button"
        >
          {{ button.false.msg }}</c-btn
        >
      </div>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      required: false,
      type: String
    },
    text: {
      required: false,
      type: String
    },
    subText: {
      required: false,
      type: String
    },
    button: {
      required: false,
      type: Object,
      default: function (vm) {
        return {
          true: {
            class: ["btn-success"]
          },
          false: {
            class: ["btn-danger"]
          }
        };
      }
    }
  },
  data() {
    return {
      modalShow: false
    };
  },
  methods: {
    show() {
      if (!this.button.true.msg) this.button.true.msg = this.$t("confirm");
      if (!this.button.false.msg) this.button.false.msg = this.$t("cancel");
      this.modalShow = true;
    },
    close() {
      this.modalShow = false;
    },
    handleOkModal() {
      this.$emit("handler", true);
      this.modalShow = false;
    },
    handleCloseModal() {
      this.modalShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmModal {
  width: auto;
}
.modal-header {
  border: 0 !important;
  padding: 0;
}

.text-text {
  margin-bottom: 0;

  word-wrap: break-word !important;
}
.text-sub {
  color: var(--font-color);

  word-wrap: break-word !important;
}
.modal-body {
  margin: auto;
  text-align: center;
}
</style>
